import { BASE_PUBLIC_API_ROOT_PATH } from '../../shared/public/constants/path.constants';

export const PUBLIC_CATEGORIES_API_PATHS = {
  GET_CATEGORIES: `${BASE_PUBLIC_API_ROOT_PATH}/categories`,
};
